
    import { defineComponent } from 'vue'
    import Chip from 'primevue/chip'
    import Dialog from 'primevue/dialog'
    import metawebInvalidRelationshipsDialogDescriptor from './MetawebInvalidRelationshipsDialogDescriptor.json'

    export default defineComponent({
        name: 'metaweb-invalid-relationships-dialog',
        components: { Chip, Dialog },
        props: { visible: { type: Boolean }, propIncorrectRelationships: { type: Array } },
        emits: ['close', 'save'],
        data() {
            return {
                metawebInvalidRelationshipsDialogDescriptor,
                incorrectRelationships: [] as any[]
            }
        },
        watch: {
            propIncorrectRelationships() {
                this.loadIncorrectRelationships()
            }
        },
        created() {
            this.loadIncorrectRelationships()
        },
        methods: {
            loadIncorrectRelationships() {
                this.incorrectRelationships = this.propIncorrectRelationships as any[]
            },
            closeDialog() {
                this.$emit('close')
            },
            save() {
                this.$emit('save')
            }
        }
    })
